const flag = "production";
const env = {
  production: {
    API_URL: "https://gaspdelivery.com/api",
    STORAGE_URL: "https://gaspdelivery.com/backend/public",
    FRONTEND_URL: "https://gaspdelivery.com",
    REACT_APP_GOOGLE_API_KEY: "AIzaSyBA_6t9dx8FICDdeUjYkoLq7HkE9y1LQwQ",
  },
  staging: {
    API_URL: "http://sp-backend.test/api",
    STORAGE_URL: "http://sp-backend.test", 
    FRONTEND_URL: "",
    REACT_APP_GOOGLE_API_KEY: "AIzaSyBA_6t9dx8FICDdeUjYkoLq7HkE9y1LQwQ",
  },
};

export default {
  ...env[flag],
  flag: flag,
};
